import React from "react";

/**
 * Small line icons per energy metric (or combined-group id), used in the KPI
 * card badges. Keyed loosely so both metric keys (e.g. "electrical_power",
 * "compressed_air_total") and group ids (e.g. "climate", "compressed_air",
 * "vacuum") resolve to a sensible icon.
 */

const svg = (children: React.ReactNode) => (
  <svg
    className="w-4 h-4"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {children}
  </svg>
);

const BOLT = svg(<path d="M13 2L4.5 13.5H11l-1 8.5 9-12H12l1-8z" />);
const THERMO = svg(
  <>
    <path d="M14 14.76V4a2 2 0 10-4 0v10.76a4 4 0 104 0z" />
  </>,
);
const DROPLET = svg(
  <path d="M12 3s6 6.4 6 10.5a6 6 0 11-12 0C6 9.4 12 3 12 3z" />,
);
const WIND = svg(
  <>
    <path d="M3 8h10a2.5 2.5 0 10-2.5-2.5" />
    <path d="M3 12h14a2.5 2.5 0 11-2.5 2.5" />
    <path d="M3 16h7" />
  </>,
);
const GAUGE = svg(
  <>
    <path d="M4 15a8 8 0 1116 0" />
    <path d="M12 15l3.5-3" />
  </>,
);
const SPEED = svg(
  <>
    <path d="M4 16a8 8 0 1116 0" />
    <path d="M12 16l4-4" />
    <path d="M12 16h.01" />
  </>,
);
const TREND = svg(<path d="M3 15l4-5 4 3 5-7 5 6" />);

export function getMetricIcon(id: string): React.ReactNode {
  if (id.startsWith("electric")) return BOLT;
  if (id === "machine_speed") return SPEED;
  if (id === "climate" || id === "ambient_temperature") return THERMO;
  if (id === "ambient_humidity") return DROPLET;
  if (id.startsWith("compressed_air")) return WIND;
  if (id.startsWith("vacuum")) return GAUGE;
  return TREND;
}
